export const roundCaratNumber = (number, precision = 3) => {
    const num = Number(number);
    if (Number.isFinite(num)) {
        const factor = Math.pow(10, precision);
        return parseFloat((Math.round(num * factor) / factor).toFixed(precision));
    }
    return number;
};
